import { render, staticRenderFns } from "./wavePicking.vue?vue&type=template&id=08b655af&scoped=true"
import script from "./wavePicking.vue?vue&type=script&lang=js"
export * from "./wavePicking.vue?vue&type=script&lang=js"
import style0 from "./wavePicking.vue?vue&type=style&index=0&id=08b655af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b655af",
  null
  
)

export default component.exports